import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { economyTypes, interactionTypes, workflowTypes, settingTypes, } from '@debbie/common/dist/blamelog/index.js';
import THEME from '../../theme.js';
import { SettingsDetails, InteractionDetails, WorkflowDetails, VoucherDetails, } from './details/index.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import RemoteTable from '../RemoteTable.js';
import { useBlameLogs } from '@debbie/cortex/dist/blamelogs/index.js';
export const BlameLogList = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(RemoteTable, { useFetch: (filter, page, pageSize) => {
                return useBlameLogs(props.refType, props.refId, { types: props.types }, page, pageSize);
            }, pageSize: 25, initFilters: {}, genKey: (bl) => bl.id, sortKeyKey: "fake", sortDirectionKey: "fake", values: {
                performedBy: {
                    label: '',
                    map: (p) => React.createElement(PerformedBy, { performedBy: p }),
                    sortable: false,
                },
                type: {
                    label: '',
                    map: (type) => lang.blameLogSimplfiedType[type],
                    sortable: false,
                },
                loggedAt: {
                    label: '',
                    map: (loggedAt) => (React.createElement("small", null, moment(loggedAt).format(THEME.DATE_FORMAT_LONG))),
                    sortable: false,
                },
                details: {
                    label: '',
                    map: (details, a) => {
                        if (economyTypes.includes(a.type)) {
                            return React.createElement(VoucherDetails, { details: details });
                        }
                        if (interactionTypes.includes(a.type)) {
                            return React.createElement(InteractionDetails, { details: details });
                        }
                        if (workflowTypes.includes(a.type)) {
                            return React.createElement(WorkflowDetails, { details: details });
                        }
                        if (settingTypes.includes(a.type)) {
                            return React.createElement(SettingsDetails, { details: details, type: a.type });
                        }
                        return `${details}`;
                    },
                    sortable: false,
                },
            } })));
};
//# sourceMappingURL=BlameLogList.js.map